<template>
  <div id="artist">
 <!-- v-bind:style="styleObject" -->

    <v-row>
      <v-col cols=12 lg=12 md=12 sm=12 align="center">
        <router-link to="/">
          <v-img
            lazy-src="/logo.jpg"
            max-width="160"
            src="/logo.jpg"
          ></v-img>
          <!-- max-width="160" -->
        </router-link>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols=12 lg=12 md=12 sm=12 align="center">

        <ArtistInfo
        :artistInfo="$route.params.artists[$route.params.items[0]]"/>

      </v-col>
    </v-row>

    <div class="pt-10">
      <v-btn
        rounded
        color="blue-grey"
        to="/"
        dark
      >
      トップに戻る
      </v-btn>
    </div>

  </div>
</template>

<script>

  import ArtistInfo from '@/components/ArtistInfo.vue'

  export default {
    name: 'Artist',
    props: ['artistsInfo'],
    components: {
      ArtistInfo,
    },
    data: () => ({
    }),
    created () {
    },
    mounted () {
      this.$vuetify.goTo(0)
    },
  }
</script>
